export default __webpack_public_path__ + "static/media/CircularStd-Book.c1441dbf.otf";